import * as React from 'react';
import { P } from '../../designSystem/typography/Body';
import { clientAccessHelper } from '../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../_contexts/ProtectedPageContext';
import { MemberPageWrapper } from '../_pageWrappers/MemberPageWrapper';
import { LearningModuleList } from '../_components/learning/LearningModuleList';


export function LearningModuleListPage (): JSX.Element
{
    
    return (

        <MemberPageWrapper selectedMenuItemKey={'learning'} breadCrumbs={[{ text: 'Opslagsværk', url: '' }]}>
            <LearningModuleListPageContent />
        </MemberPageWrapper>
    );
}

function LearningModuleListPageContent (): JSX.Element
{
    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['ViewCustomFormAnswerList']);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return <LearningModuleList />;
}
